import { render, staticRenderFns } from "./StockInfoList.vue?vue&type=template&id=b9d64bb6&scoped=true&"
import script from "./StockInfoList.vue?vue&type=script&lang=js&"
export * from "./StockInfoList.vue?vue&type=script&lang=js&"
import style0 from "./StockInfoList.vue?vue&type=style&index=0&id=b9d64bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d64bb6",
  null
  
)

export default component.exports